import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { BuilderEstimatorSteps } from "@/enums/BuilderEstimatorSteps";
  import BuilderDesktopStepIndicator from "./BuilderDesktopStepIndicator.vue";
  import BuilderEstimatorQuoteSummaryCollapsed from "@/components/builder/estimator-tool/BuilderEstimatorQuoteSummaryCollapsed.vue";
  import { HouseDesignInterface } from "@/types/HouseDesignInterface";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderStepDesktopNavigation',
  props: {
    steps: {},
    currentStep: {},
    totalPrice: {},
    errorOnCurrentStep: { type: Boolean },
    builderLogo: {},
    builderColor: {},
    houseDesign: {}
  },
  emits: [
    "select-next",
    "select-prev",
    "toggle-summary-modal",
  ],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "fcdcf2be": (_ctx.builderColor)
}))

  const props = __props;

  const emit = __emit;

  const onSelectNext = () => {
    emit("select-next");
  };

  const onSelectPrev = () => {
    emit("select-prev");
  };

  const onToggleSummaryModal = () => {
    emit("toggle-summary-modal");
  };

const __returned__ = { props, emit, onSelectNext, onSelectPrev, onToggleSummaryModal, get BuilderEstimatorSteps() { return BuilderEstimatorSteps }, BuilderDesktopStepIndicator, BuilderEstimatorQuoteSummaryCollapsed, get HouseDesignInterface() { return HouseDesignInterface } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})